<template>

  <div>

    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>
    <v-snackbar
        v-model="snackbar.success"
        color="success"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.successMessage }}
    </v-snackbar>

    <v-dialog v-model="show" persistent max-width="600px">
      <LoadingDialog v-model="showLoadingDialog"></LoadingDialog>

      <v-card>
        <v-card-title>
          <h2>Change Password</h2>
          <v-spacer></v-spacer>
          <v-btn flat icon color="itoviGrayMid" @click="resetAndClose"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-0">






          <v-form ref="passwordForm" v-model="passwordFormValid" lazy-validation>
            <v-container fluid grid-list-md>
              <v-layout align-start justify-space-between wrap>
                <v-flex d-flex xs12>
                  <v-text-field :rules="passwordFormRules" v-model="password" label="Password" type="password" required></v-text-field>
                </v-flex>
                <v-flex d-flex xs12>
                  <v-text-field :rules="[passwordsMatch]" v-model="confirmPassword" label="Confirm Password" type="password" required></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>




        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="resetAndClose">Cancel</v-btn>
          <v-btn color="primary" flat @click="submitPasswordChange">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
  import api from "../../../services/api_endpoints"
  import LoadingDialog from "../../LoadingDialog"

  export default {
    components: {
      LoadingDialog
    },
    data: ()=> ({
      passwordFormValid: true,
      showLoadingDialog: false,
      password: '',
      confirmPassword: '',
      passwordFormRules: [
        v => !!v || 'This field is Required',
        v => (!!v && v.length >= 6) || 'Password must be at least 6 characters'
      ],
      snackbar: {
        success: false,
        error: false,
        timeout: 1500,
        errorMessage: "An unknown error occurred",
        successMessage: "Password changed successfully"
      },
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      passwordsMatch() {
        return this.password === this.confirmPassword || 'Passwords do not match'
      },
      resetAndClose() {
        this.$refs.passwordForm.reset()
        this.show = false
      },
      async submitPasswordChange() {
        if (!this.$refs.passwordForm.validate()) return

        this.showLoadingDialog = true
        let response = await api.submitPasswordChange(this.password)
        this.showLoadingDialog = false

        if (response.success) {
          this.snackbar.success = true
          this.resetAndClose()
        } else {
          this.snackbar.error = true
        }
      }
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
